import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { Box, Button, Flex, Heading } from '@chakra-ui/react'
import { Input, Select } from '@/components/Form'
import { ListStatus } from '@/constants/api.constant'

import { tableTypeOptions } from '../../constants/tableProfile.constant'
import { toast } from 'react-toastify'
import { tableInitialState } from '@/components/Table/FullTable/FullTable'
import useTableProfile from '@/features/tableProfiles/useTableProfile'

//API

//Constant

const CreateTableProfilePage = () => {
  //State

  const methods = useForm()
  const navigate = useNavigate()
  const { useCreateTableProfile } = useTableProfile()
  const createTableProfile = useCreateTableProfile()

  const onSubmit = async (data) => {
    try {
      const res = await createTableProfile.mutateAsync({
        tableType: data.tableType,
        profileName: data.profileName,
        status: ListStatus.ACTIVE,
        isCreatedFromAdmin: true,
        tableDetails: tableInitialState,
      })
      if (res?.data?._id) {
        navigate(`/admin/tableProfiles/${res?.data?._id}`)
      }
    } catch (err) {
      toast.error(err?.message ?? '')
    }
  }
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
          <Flex p={5} borderBottom="1px solid #d8dbe0">
            <Heading> Create Default Profile </Heading>
          </Flex>
          <Box p="5">
            <Flex direction={'column'} gap="3">
              <Input name="profileName" label="Profile Name" isRow isRequired />
              <Select name="tableType" label="Table Type" options={tableTypeOptions} isRow isRequired />
            </Flex>
            <Button mt="6" colorScheme="blue" type="submit">
              Save
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Box>
  )
}

export default CreateTableProfilePage
